export default __webpack_public_path__ + "static/media/icecream.116dda6e.jpg";